<script lang="ts" setup>
import type { PropType } from "@vue/runtime-core";
import { computed, defineProps } from "vue";
import BaseIcon from "@/components/base/BaseIcon.vue";

const props = defineProps({
  icon: {
    type: String,
    default: "arrow",
  },
  isButton: {
    type: Boolean,
    default: false,
  },
  position: {
    type: String as PropType<"left" | "right" | "bottom" | "top">,
    default: "right",
  },
  folder: {
    type: String,
    default: "ui",
  },
  color: {
    type: String as PropType<
      | "customer"
      | "white"
      | "white-opacity-15"
      | "white-opacity-40"
      | "grey-full"
      | "grey-secondary"
      | "primary"
      | "secondary"
    >,
    default: "white",
  },
  size: {
    type: String as PropType<"small" | "medium" | "large" | "extra-large">,
    default: "medium",
  },
  radius: {
    type: String,
    default: "50%",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  isOriginalColor: {
    type: Boolean,
    default: false,
  },
});

const classes = computed(() => {
  return [
    `--color-${props.color}`,
    `--size-${props.size}`,
    `--${props.position}`,
    { "--disabled": props.disabled },
  ];
});

const tag = computed(() => {
  if (props.isButton) return "button";
  else return "div";
});
</script>

<template>
  <component :is="tag" class="base-figure-for-icon" :class="classes">
    <BaseIcon
      :folder="folder"
      :name="icon"
      :position="position"
      :isOriginalColor="isOriginalColor"
    />
  </component>
</template>

<style lang="scss" scoped>
@import "@/assets/style/main";

.base-figure-for-icon {
  border-radius: v-bind(radius);
  transition: all 0.4s;
  //cursor: pointer;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  @media (max-width: 768px) {
  }

  @at-root button#{&} {
    cursor: pointer;
  }

  &.--color-white-opacity-40 {
    background: #ffffff66;
    color: var(--color-white);

    &:not(div):hover {
      background: var(--color-grey-light);
    }

    &:not(div):active {
      background: var(--color-grey-light);
      border: 1px solid var(--color-text-secondary);
    }
  }

  &.--color-white-opacity-15 {
    background: #ffffff26;
    color: var(--color-white);

    &:not(div):hover {
      background: var(--color-grey-light);
    }

    &:not(div):active {
      background: var(--color-grey-light);
      border: 1px solid var(--color-text-secondary);
    }
  }

  &.--color-white {
    background: var(--color-white);
    color: var(--color-secondary);

    &:not(div):hover {
      // background: var(--color-bg-primary);
    }

    &:not(div):active {
      background: var(--color-white);
      border: 1px solid var(--color-text-secondary);
    }
  }

  &.--color-grey-secondary {
    background: var(--color-bg-primary);
    color: var(--color-secondary);

    &:not(div):hover {
      background: var(--color-grey-blue);
    }

    &:not(div):active {
      background: var(--color-white);
      border: 1px solid var(--color-text-secondary);
    }
  }
  &.--color-grey-full {
    background: var(--color-bg-primary);
    color: var(--color-grey-light);

    &:not(div):hover {
      background: var(--color-grey-blue);
    }

    &:not(div):active {
      background: var(--color-white);
      border: 1px solid var(--color-text-secondary);
    }
  }

  &.--color-primary {
    background: var(--color-primary);
    color: var(--color-white);

    &:hover {
      background: color-mix(in srgb, var(--color-primary), #000 20%);
    }

    &:active {
      background: color-mix(in srgb, var(--color-primary), #000 20%);
      border: 1px solid var(--color-white);
    }
  }
  &.--color-secondary {
    background: var(--color-secondary);
    color: var(--color-white);
  }

  &.--color-customer {
    //background: inherit;
  }

  &.--size-medium {
    width: 36px;
    height: 36px;
    --icon-size: 24px;

    @media (max-width: 768px) {
    }
  }
  &.--size-large {
    width: 48px;
    height: 48px;
    --icon-size: 24px;

    @media (max-width: 768px) {
    }
  }
  &.--size-extra-large {
    width: 64px;
    height: 64px;
    --icon-size: 32px;

    @media (max-width: 768px) {
      width: 48px;
      height: 48px;
      --icon-size: 24px;
    }
  }

  &.--size-small {
    width: 24px;
    height: 24px;
    --icon-size: 20px;

    @media (max-width: 768px) {
      //padding: 15px 40px;
    }
  }

  &:not(div):active {
    background: var(--color-white);
    border: 1px solid var(--color-secondary);
  }

  &.--disabled {
    background: var(--color-grey-blue);
    pointer-events: none;
  }
}
</style>
